import { Controller } from "@hotwired/stimulus"

// modified, but loosely resembling, https://www.youtube.com/watch?v=DS6DJjrvg5c
// Connects to data-controller="auto-save"
export default class extends Controller {
  static values = { updateActionFromResponse: Boolean }

  connect() {
    this.form = this.element
    this.activeFetch = null
  }

  save(event) {
    // During development it's helpful to avoid sending concurrent requests to the server.
    if (rails_env == "development" && this.activeFetch != null) {
      // We're still waiting for the last save to happen.
      return;
    }

    this.mostRecentSave = event.timeStamp
    this.updateStatus("Saving…", "text-support-dark-600")

    setTimeout(() => {
      if (this.mostRecentSave === event.timeStamp) {
        const formData = new FormData(this.form)

        this.activeFetch = fetch(this.form.action, {
          method: this.form.method,
          body: formData,
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            "Accept": "text/vnd.turbo-stream.html",
          }
        }).then((response) => {
          if (response.ok && this.updateActionFromResponseValue) {
            this.updateFormAction(response.headers.get("X-Autosave-Action"))
          }

          if (response.ok) {
            this.updateStatus("Saved", "text-alert-green-700")
          } else {
            this.updateStatus("Couldn’t save", "text-alert-red-700")
          }
          this.activeFetch = null
        }).catch(() => {
          this.updateStatus("Couldn’t save", "text-alert-red-700")
          this.activeFetch = null
        })
      } else {
        // there was a change within the timeout, so we don't save
      }
    }, 1000)
  }

  updateFormAction(action) {
    if (!action) return

    this.form.action = action
    let methodOverride = this.form.querySelector('input[name="_method"]')
    if (!methodOverride) {
      methodOverride = this.form.ownerDocument.createElement("input")
      methodOverride.type = "hidden"
      methodOverride.name = "_method"
      this.form.appendChild(methodOverride)
    }
    methodOverride.value = "patch"
  }

  updateStatus(message, colorClass) {
    const status = this.form.querySelector('[data-auto-save-target="status"]')
    if (!status) return

    status.textContent = message
    status.classList.remove("text-support-dark-600", "text-alert-green-700", "text-alert-red-700")
    status.classList.add(colorClass)
  }
}
